var xstorage_main = function(){},
	ystorage_main = function(){},
	version = '05.11';
	
xstorage_main.prototype = {
	check:function(){
		if (localStorage.version !== version){
			localStorage.clear();
			localStorage.version = version;
		}
	},
	set:function(index, value){
		localStorage[index] = value;
	},
	get:function(index){
		return localStorage[index];
	},
	clear:function(index, key){
		if(!key){
			delete localStorage[index];
			return;
		}
		
		var obj = this.getobj(index);
		delete obj[key];
		this.setobj(index, obj);
	},
	setobj:function(index, obj){
		localStorage[index] = JSON.stringify(obj);
	},
	getobj:function(index){
		return (localStorage[index]) ? $.parseJSON(localStorage[index]) : {};
	},
	setobjkey:function(index, key, value){ /* saugo objekto objekta {filters:{Clients:{Name:'lexita'}}}*/
		var obj = this.getobj(index);
		obj[key] = value;
		this.setobj(index, obj);
	},
	getobjkey:function(index, key){ /* gauna objekto objekta {filters:{Clients:{Name:'lexita'}}}*/
		return this.getobj(index)[key] || {};
	}
};

ystorage_main.prototype = {
	set:function(index, value){
		$.ajax({
			type: 'POST',
			url: '/php/actions/storage.php',
			data: {
				key: index,
				value: value
			}
		});
	}
};

var xstorage = new xstorage_main();
var ystorage = new ystorage_main();